/*
 * File: PrivacyPolicy.styles.js
 * Project: seesaw-marketplace-app
 *
 * Created by Brendan Michaelsen on February 8, 2022 at 3:21 PM
 * Copyright © 2022 Seesaw Technologies, LLC. All rights reserved.
 *
 * Last Modified: January 7, 2023 at 10:05 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
    max-width: 700px;
    overflow-wrap: break-word;
    box-sizing: border-box;
	margin: 0 auto;
`;
